import ProyeccionesGastos from "./ProyeccionesGastos";
export default ProyeccionesGastos;